import {
    Heading,
    Box,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import EmailLink from "components/links/email-link";
import { PhoneNumberLink } from "components/links/phone-number-link";
import { useTranslation } from "react-i18next";

function ResturantInformation() {
    const { t } = useTranslation();
    const { data: settings, isPending } = useExternalBookingSettings();

    if (isPending || !settings) return null;

    const { unitsMetaData, email, address } = settings;
    return (
        <Box textAlign="left" justifyItems="start">
            <Heading
                as="h4"
                fontWeight={"medium"}
                fontSize={ThemeFontSizeVariable.Large}
                pb={ThemeSpaceVariable.Small}
            >
                {t("resturangInformation.contactInformation")}
            </Heading>
            <Text>{unitsMetaData.name}</Text>
            <Text>{address}</Text>
            <Text>
                <PhoneNumberLink />
            </Text>
            <Text>
                <EmailLink email={email} />
            </Text>
        </Box>
    );
}

export default ResturantInformation;
